export default {
    DEFAULT: 1000,
    FWU_AUTH: 500,
    FWU_END_PROGRAMMING: 2500,
    FWU_PROGRAM_BLOCKS: 1000,
    FWU_START_PROGRAMMING: 2000,
};
